/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */

import CommentsSection from '../../common/CommentsSection';

const FRY7QComment = ({
    getFRY9CUser, fry9cComment, setFRY9CComment, commentLoading, addFRY9CComment,
    loading, getUserCommentsForFRY9C, fry9cEdit, handleFRY9CClick, fry9cShow,
    fry9cTarget, onFRY9CEditClick, onFRY9CClickDelete, fry9cSelectedIndex,
    fry9cSelectedComment, setFRY9CSelectedComment, onFRY9CCancelClick, onFRY9CClickSave,
}) => (
    <CommentsSection
        getUser={getFRY9CUser}
        comment={fry9cComment}
        setComment={setFRY9CComment}
        commentLoading={commentLoading}
        addComment={addFRY9CComment}
        loading={loading}
        getUserComments={getUserCommentsForFRY9C}
        edit={fry9cEdit}
        handleClick={handleFRY9CClick}
        show={fry9cShow}
        target={fry9cTarget}
        onEditClick={onFRY9CEditClick}
        onClickDelete={onFRY9CClickDelete}
        selectedIndex={fry9cSelectedIndex}
        selectedComment={fry9cSelectedComment}
        setSelectedComment={setFRY9CSelectedComment}
        onCancelClick={onFRY9CCancelClick}
        onClickSave={onFRY9CClickSave}
    />
);

export default FRY7QComment;
